import React from 'react'
import { TextField, Button, Card, CardContent, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { TourPackageCard } from '../components/TourpackageCard/TourPackageCard';
import { useGetOrder } from '../hooks/useGetOrder';
import { toCurrencyFormat, toDate } from '../utils/utils';
import appAxios from '../services/axios';
import { toDocumentFormatWithTime } from '../utils/dateHelper';

export const OrderDetails = () => {
    const { orderID } = useParams();
    const navigate = useNavigate();
    const { data: order, isLoading, error } = useGetOrder(orderID);

    if (isLoading) {
        return <div>Loading...</div>
    }
    if (error) {
        return <div>Error: {error.message}</div>
    }

    const handlePayPrepayment = () => {
        const windowOuterHeight = window.outerHeight;
        const windowOuterWidth = window.outerWidth;

        const queryParams = new URLSearchParams();
        queryParams.set('orderID', orderID);
        queryParams.set('type', 'prepay');
        queryParams.set('platform', 'web');
        queryParams.set('width', windowOuterWidth);
        queryParams.set('height', windowOuterHeight);

        window.location.href = appAxios.defaults.baseURL + '/app/bcc/payments/create?' + queryParams.toString();
    }

    const handlePayFullPayment = () => {
        const windowOuterHeight = window.outerHeight;
        const windowOuterWidth = window.outerWidth;

        const queryParams = new URLSearchParams();
        queryParams.set('orderID', orderID);
        queryParams.set('type', 'full');
        queryParams.set('width', windowOuterWidth);
        queryParams.set('height', windowOuterHeight);
        queryParams.set('platform', 'web');

        window.location.href = appAxios.defaults.baseURL + '/app/bcc/payments/create?' + queryParams.toString();
    }
    return (
        <section>
            <div className='flex justify-between'>
                <Button variant='outlined' color='primary' onClick={() => navigate('/tourpackages')}>Вернутся на страницу поиска</Button>
            </div>
            <h1>Детали заказа</h1>
            <Card className='mb-4'>
                <CardContent>
                    <Typography variant='h6'>Детали заказа</Typography>
                    <Typography variant='body1'>Номер заказа: {order.id}</Typography>
                    <Typography variant='body1'>Стоимость турпакета в USD: <strong>{toCurrencyFormat(order.totalPrice, 'USD')}</strong></Typography>
                    <Typography variant='body1'>Стоимость турпакета в KZT: <strong>{toCurrencyFormat(order.totalPriceKZT, 'KZT')}</strong></Typography>
                    <Typography variant='body1'>Дата заказа: {toDocumentFormatWithTime(order.createdAt)}</Typography>
                    <Typography variant='body1'>Статус заказа: <strong>{order.bookingStatus?.name}</strong></Typography>
                </CardContent>
            </Card>

            <TourPackageCard tourPackage={order.tourPackage} options={{ showPrice: false }} />

            <section className='mt-4'>
                <h1>Информация о покупателе</h1>
                <Card className='mb-4'>
                    <CardContent>
                        <Typography variant='body1'>Имя: {order.buyer.lastName} {order.buyer.firstName}</Typography>
                    </CardContent>
                </Card>
            </section>

            <div className='flex justify-end gap-4 mt-4'>
                <Button variant='contained' color='primary' onClick={handlePayPrepayment}>Оплатить предоплату {toCurrencyFormat(10000, 'KZT')}</Button>
                <Button variant='contained' color='secondary' onClick={handlePayFullPayment}>Оплатить полную стоимость {toCurrencyFormat(order.totalPriceKZT, 'KZT')}</Button>
            </div>
        </section>
    )
}
